const angular = require('angular');
const app = angular.module('learn-directives');
var croppieImport = require('../imports/croppie');

/**
 * Defines the Image Editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('avatarCrop', ['Application', 'S3Uploads', 'Upload', '$timeout', function (Application, S3Uploads, Upload, $timeout) {
  return {
    restrict: 'E',
    scope: {
      src: '=',
      resultToggle: '=',
      percent: '=?',
      loading: '=?',
      submit: '&'
    },
    link: function (scope, element, attrs) {
      if (!scope.src) {
        return;
      }

      var el = document.createElement('div');
      el.style.position = 'relative';
      var tempCover = document.createElement('div');
      tempCover.id = 'temp-cover';
      tempCover.style.position = 'absolute';
      tempCover.style.top = '0';
      tempCover.style.left = '0';
      tempCover.style.width = '100%';
      tempCover.style.height = '100%';
      tempCover.style['z-index'] = '2';
      tempCover.style['background-color'] = 'lightgray';

      el.appendChild(tempCover);

      var vanilla;
      async function prepareCroppie() {
        const croppieModule = await croppieImport.importModule();
        const Croppie = croppieModule.default;
        vanilla = new Croppie(el, {
          viewport: { width: 200, height: 200, type: 'square'},
          boundary: { width: 300, height: 300 },
          mouseWheelZoom: false
        });
        return vanilla;
      }
      prepareCroppie().then(() => {
        vanilla.bind({
          url: scope.src
        });
  
        element[0].appendChild(el);
        $timeout(function() {
          el.removeChild(tempCover);
          scope.$apply();
        }, 1500);
      });

      scope.$watch('resultToggle', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          //on button click
          scope.loading = true;
          vanilla.result('blob', 'original').then(function(blob) {
            var file = new File([blob], 'uploaded-img.jpeg');

            S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: file
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                scope.percent = percent;
              }).success(function(data) {
                var link = cloudFrontLink;
                if (!link) {
                  return;
                }
                scope.submit({link: link});
                scope.loading = false;
              }).catch(function(error) {
                console.log('upload error', error);
              });
            }, function(error) {
              console.log('s3url error', error);
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });

          });
        }
      });
    }
  };
}]);